import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthContext';
import { router } from '@/app/router';
import { AppToastContainer } from '@/components/common/AppToastContainer';
import '@/i18n';

/** Composes the app-wide providers: i18n (side-effect import), auth, router, toasts. */
export function AppProviders() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
      <AppToastContainer />
    </AuthProvider>
  );
}
